window.$ = window.jQuery = require('jquery')

import styles from '../scss/default.scss'

// general
import Accordion from './components/accordion'
// import Form from './components/Form'
import FormSubmit from './components/FormSubmit'
// import Modal from './components/Modal'
import 'bootstrap'
import { Tooltip as BootstrapTooltip } from 'bootstrap';

import './datepicker/jquery-ui-datepicker.js'
import './button/button.js'
import Tooltip from './components/Tooltip'

// pages
import Cart from './cart/Cart'
import SessionStorage from './sessionStorage'
import CalculateTotalSum from './cart/CalculateTotalSum'
import TicketOptions from './tickets/TicketOptions'
import Seating from './tickets/seating/Index'
import SplitSeatsModal from './components/SplitSeatsModal'
import MobileMenu from './components/MobileMenu'
import Featured from './start/Featured'
import Products, { SelectHref } from './components/Products'
import Offers from './start/Offers'
import TicketsModal from './tickets/TicketsModal'
import Account from './account'
import EventDesc from './tickets/EventDesc'
import TicketsSpan from './start/TicketsSpan'
import Giftcertificate from './giftcertificate/'
import Giftcertificate2 from './giftcertificate/GiftCertificate2'
import Customerdetails from './checkout/customerdetails'
import Paytypes from './checkout/paytype'
import ProductsFilter from './components/ProductsFilter'
import ChangeChecker from './order/ChangeChecker'
import Msie from './msie/'
import SeatSelectionSetting from './tickets/seating/SeatSelectionSetting'
import DoubleClickers from './components/double-click'
import EventListComponent from './list/EventList'
import RefundComponent from './refund/Refund'
import CashierCheckoutComponent from './checkout/CashierCheckout'
import CashierOrderSearchComponent from './cashier/CashierOrderSearch'
import CashierRefunds from './cashier/CashierRefunds'
import QrCodeGenerator from './qrcode/QrCodeGenerator';
import ReservationTimer from './order/ReservationTimer';
import CartTimer from './cart/CartTimer';
import { setupUnlockForm } from "./tickets/unlockForm";
import { setupTicketSelector } from './tickets/ticketSelector';
import { setupEvent } from './tickets/Event';
import AlertTimeOut from './components/alertTimeOut';
import Card from './components/Card';
import Navbar from './components/Navbar';
window.addEventListener(
    'touchstart',
    function onFirstTouch() {
        window.USER_IS_TOUCHING = true
        window.removeEventListener('touchstart', onFirstTouch, false)
    },
    false
)
import ClampToggle from './components/ClampToggle'

window.addEventListener('pageshow', function (event) {
    const loaders = document.querySelectorAll('.loader');
    if (event.persisted) {
        loaders.forEach(loader => {
            loader.style.display = 'none';
            loader.classList.remove('show');
        });
    }
    else {
        loaders.forEach(loader => {
            loader.style.display = 'none';
            loader.classList.remove('show');
        });
    }
});

document.addEventListener('DOMContentLoaded', () => {
    new SessionStorage()
    new FormSubmit()
    new Cart()
    new CalculateTotalSum()
    new TicketOptions()
    new Seating()
    new SplitSeatsModal()
    new MobileMenu()
    new Featured()
    new Offers()
    new TicketsModal()
    new Products()
    new ProductsFilter()
    new EventDesc()
    new Accordion()
    new Account()
    new TicketsSpan()
    new Giftcertificate()
    new Giftcertificate2()
    new Customerdetails()
    new Paytypes()
    new SelectHref()
    new ChangeChecker()
    new Msie()
    new SeatSelectionSetting()
    new DoubleClickers()
    new EventListComponent()
    new RefundComponent()
    new CashierCheckoutComponent()
    new CashierOrderSearchComponent()
    new CashierRefunds()
    new QrCodeGenerator()
    new Tooltip(BootstrapTooltip);
    if (useNewHeader && useNewHeader.toLowerCase() === "true") {
        new CartTimer();
    }
    else
    {
        new ReservationTimer();
    }
    setupTicketSelector();
    setupEvent();
    setupUnlockForm();
    new AlertTimeOut();
    new Card();
    new Navbar();
    new ClampToggle();
    window.addEventListener('pageshow', function (event) {
        if (event.persisted || performance.getEntriesByType('navigation').some(entry => entry.type === 'back_forward')) {
            document.querySelectorAll('.input-group input[type="number"]').forEach(input => {
                input.value = 0;
            });
            setupEvent();
        }
    });

})



// const events = ["pagehide", "pageshow", "unload", "load"];
//
// const eventLogger = (event) => {
//     switch (event.type) {
//         case "pagehide":
//         case "pageshow": {
//             let isPersisted = event.persisted ? "persisted" : "not persisted";
//             console.log(`Event: ${event.type} - ${isPersisted}`);
//             break;
//         }
//         default:
//             console.log(`Event: ${event.type}`);
//             break;
//     }
// };
//
// events.forEach((eventName) => window.addEventListener(eventName, eventLogger));